import {inject, Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs';
import {filter} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StagingLayoutService {
  private readonly showLayoutSubject = new BehaviorSubject<boolean>(true);
  showLayout$ = this.showLayoutSubject.asObservable();

  private readonly fullscreenRoutes: string[] = ['/staging-login'];
  private readonly router = inject(Router);

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const hideLayout = this.fullscreenRoutes.some((route) =>
          event.urlAfterRedirects.startsWith(route),
        );
        this.showLayoutSubject.next(!hideLayout);
      });
  }
}
